import { theme } from '@branchjs/neo-components';
import { css } from 'emotion';

const center = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const appTile = css`
  ${center};
  width: ${theme.spacing(6)};
  height: ${theme.spacing(6)};
  left: ${theme.spacing(4.5)};
  top: ${theme.spacing(3)};

  box-shadow: ${theme.shadows[0]};
  border-radius: ${theme.spacing(1)};
`;

const content = css`
  ${center};
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
  width: ${theme.spacing(11)};
  height: ${theme.spacing(11)};
  left: ${theme.spacing(2)};
  top: ${theme.spacing(2)};
  cursor: pointer;
  border-radius: ${theme.spacing(1)};

  &:hover {
    background: ${theme.colors.gray[200]};
  }
`;

export const appEntryStyles = {
  discoTile: css`
    background: #5ba3fd;
    ${appTile};
  `,
  saasTile: css`
    background: #38bfa7;
    ${appTile};
  `,
  activeTile: css`
    background: ${theme.colors.gray[100]};
    ${content};
  `,
  content,
};
